/**
 * @module support/pdl
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// tslint:disable
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdlComponent } from './components/pdl.component';
import { PdlDirective } from './directive/pdl.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [PdlDirective, PdlComponent],
  exports: [PdlDirective, PdlComponent],
})
export class PdlModule {
  constructor() {}
  static forChild(): ModuleWithProviders<PdlModule> {
    return {
      ngModule: PdlModule,
    };
  }
}
